@if (presentation() === 'dropdown') {
  <div class="relative hidden lg:block">
    <button
      type="button"
      aria-haspopup="menu"
      [attr.aria-expanded]="langOpen()"
      (click)="toggleLangMenu()"
      [class]="
        cn(
          'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold tracking-wide transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
          isDark()
            ? 'text-white/80 hover:text-primary-glow focus-visible:ring-offset-ink'
            : 'text-foreground/70 hover:text-primary focus-visible:ring-offset-background'
        )
      "
      [attr.aria-label]="'common.changeLanguage' | transloco: { lang: localeLabel(currentLocale) }"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="h-3.5 w-3.5"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
        <path d="M2 12h20" />
      </svg>
      {{ localeLabel(currentLocale) }}
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        [class]="cn('h-3 w-3 transition-transform', langOpen() && 'rotate-180')"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </button>

    @if (langOpen()) {
      <div
        role="menu"
        [class]="
          cn(
            'ios-menu absolute right-0 top-full z-50 mt-3 w-44 origin-top-right',
            isDark() ? 'ios-menu--dark' : 'ios-menu--light'
          )
        "
      >
        @for (locale of localeOptions; track locale.code) {
          <button
            type="button"
            role="menuitem"
            (click)="selectLocale(locale.code)"
            [class]="
              cn(
                'ios-menu-item w-full justify-between',
                currentLocale === locale.code && 'ios-menu-item--active'
              )
            "
          >
            <span>{{ locale.labelKey | transloco }}</span>
            <span class="text-[10px] font-bold tracking-wider opacity-60">
              {{ localeLabel(locale.code) }}
            </span>
          </button>
        }
      </div>
    }
  </div>
} @else {
  <div class="border-t border-black/[0.06] px-5 py-4">
    <div
      class="mb-2 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="h-3.5 w-3.5"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
        <path d="M2 12h20" />
      </svg>
      {{ 'common.language' | transloco }}
    </div>
    <div class="flex flex-wrap gap-2">
      @for (locale of localeOptions; track locale.code) {
        <button
          type="button"
          (click)="selectLocale(locale.code)"
          [class]="
            cn(
              'rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors',
              currentLocale === locale.code
                ? 'border-primary bg-primary text-primary-foreground'
                : 'border-black/[0.08] text-foreground/70 hover:border-primary/40 hover:text-primary'
            )
          "
        >
          {{ localeLabel(locale.code) }}
        </button>
      }
    </div>
  </div>
}
